import type { Release } from '../releases';

export default {
  id: '2026-11-04-site-journals',
  at: '2026-11-04T12:24:00Z',
  title: 'Журналы бетонных, сварочных и изоляционных работ, журнал входного контроля',
  modules: ['site', 'documents'],
  items: [
    'На странице журналов работ можно выбрать журнал: общий, бетонных, сварочных, антикоррозионных и изоляционных работ или входного контроля.',
    'Работа попадает в журнал своего вида, если к ней применён шаблон исполнительной документации этого вида («Бетонирование», «Сварка», «Изоляция»). Записи берутся из принятых отчётов смены.',
    'В записях журнала видны материалы, списанные по работе в отчёте смены, — без цен.',
    'Журнал входного контроля собирает приёмки поставок на площадке и решения ОТК по приходам склада.',
  ],
  why: 'Журналы по видам работ и входного контроля вели вручную, хотя все данные уже есть в принятых отчётах и приёмках. Теперь они собираются сами и не расходятся с отчётами.',
  link: '/documents/journals',
} satisfies Release;
